import { useTranslation } from 'react-i18next';
import { articleContent, type ArticleContent } from '@/mocks/articleContent';

export function getArticleContent(lang: string, slug: string): ArticleContent {
  const code = lang?.split('-')[0] ?? 'en';
  return (
    articleContent[code]?.[slug] ??
    articleContent.en?.[slug] ??
    articleContent.en['usfans-spreadsheet-guide']
  );
}

export function useArticleContent(slug: string): ArticleContent {
  const { i18n } = useTranslation();
  return getArticleContent(i18n.language, slug);
}